import { driver, DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import { baseTourConfig, injectTourStyles } from './tourConfig';
import { TourId } from '@/store/tourStore';

export const TOUR_ID: TourId = 'create-tournament';

export const createSteps = (navigate: (path: string) => void): DriveStep[] => [
  {
    popover: {
      title: 'Create Your First Tournament',
      description: 'Tournaments are one-time competitive events - perfect for weekend competitions, championships, or bracket-style play. Let\'s create one from the Competitions page!',
      side: 'over',
      align: 'center',
    },
  },
  {
    element: '[data-tour="nav-organize"]',
    popover: {
      title: 'Go to Competitions',
      description: 'Competitions is where you create and manage all your tournaments and leagues in one place.',
      side: 'right',
      align: 'start',
      onNextClick: (element, step, options) => {
        navigate('/admin/organize');
        setTimeout(() => {
          options.driver.moveNext();
        }, 500);
      },
    },
  },
  {
    element: '[data-tour="organize-add-tournament"]',
    popover: {
      title: 'Add a Tournament',
      description: 'Click Add Tournament to open the create dialog. Name it (like "Spring Cup 2026"), review the contests and divisions pre-filled from your sport\'s template, and hit Create. Registration opens in the same step unless you uncheck it.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="organize-tournaments"]',
    popover: {
      title: 'Your Tournament Tree',
      description: 'Tournaments appear here with their contests and divisions. Expand one to add more inline, drag to reorder, and use the "..." menu for Settings, Payment, and more.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="nav-registration"]',
    popover: {
      title: 'Next: Review Your Registration',
      description: 'Your registration was created with the tournament. Go to Registrations to fine-tune dates, fees, and forms, and watch team signups come in!',
      side: 'right',
      align: 'start',
    },
  },
];

export const startCreateTournamentTour = (onComplete?: () => void, navigate?: (path: string) => void) => {
  injectTourStyles();

  const steps = createSteps(navigate || (() => {}));
  
  const driverObj = driver({
    ...baseTourConfig,
    steps,
    onDestroyStarted: () => {
      onComplete?.();
      driverObj.destroy();
    },
  });

  driverObj.drive();
  return driverObj;
};
